import { Flex, FlexProps, Spin, Typography } from "antd";
import styled from "styled-components";
import { radius } from "@libertify/ui";

interface SpeakerItemProps extends Partial<FlexProps> {
  ghost?: boolean;
  title?: string;
}

const SpeakerItem: React.FC<SpeakerItemProps> = ({
  children,
  title,
  ghost,
  ...props
}) => {
  const { style, ...restOfProps } = props;
  return (
    <Flex
      vertical
      style={{ flex: "0 1", position: "relative" }}
      gap={8}
      align="center"
      justify="center"
      onClick={props.onClick}
    >
      <Flex
        vertical
        className={props.className}
        justify="center"
        align="center"
        style={{
          width: 128,
          height: 128,
          borderRadius: radius.box,
          backgroundColor: "white",
          ...style,
        }}
        {...restOfProps}
      >
        {ghost ? <StyledSpin spinning={ghost} /> : children}
      </Flex>
      {title && <StyledText ellipsis>{title}</StyledText>}
    </Flex>
  );
};

export default SpeakerItem;

const StyledSpin = styled(Spin)`
  height: unset !important;
`;

const StyledText = styled(Typography.Text)`
  max-width: 128px;
  position: absolute;
  bottom: -30px;
  left: 0;
  width: 100%;
  text-align: center;
`;
